export default {
  zh: {
    setPassWord: '设置密码',
    confirmPassword: '确认密码',
    submit: '确认',
    networkError: '网络错误，请稍后再试',
    setPasswordSuccess: '新密码设置成功',
    confirmErrorMsg: '确认密码内容不匹配'
  },
  en: {
    setPassWord: 'Set Password',
    confirmPassword: 'Reenter Password',
    submit: 'Submit',
    networkError: 'Network error, please try again later',
    setPasswordSuccess: 'Success',
    confirmErrorMsg: 'The two passwords do not match'
  }
}



// WEBPACK FOOTER //
// ./src/views/safecenter/setNewPassword/lang.js